import { getAxiosClientWithToken, getAxiosClientWithJWTToken } from "api";
import { handleFormData } from 'lib/utils';
import { MyPlaceData, TurnOnOff } from 'types';
import { ListPlaceRequest } from 'redux/slice/listPlaceSlice';

export const getListPlace = (params: ListPlaceRequest) => {
    return getAxiosClientWithJWTToken().get("facility/filter", { params });
};

export const createPlace = (params: MyPlaceData) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`/facility/create`, params);
};

export const getPrefecture = (params: { zipcode?: number , lang?: string | undefined }) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/getCity', { params });
};

export const getCitybyState = (params: { state?: string }) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get('/getCity', { params });
};

export const editPlace = (params:MyPlaceData) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`/facility/update`, params);
};

export const getDetailPlace = (params: { id?: Number | string }) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get(`/facility/details?uuid=${params.id}`);
};

export const getPlaceType = () => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get("/facilitytypes");
};

export const getState = () => {
  const restClient = getAxiosClientWithJWTToken();
  return restClient.get("/getState");
};

export const getPlaceStatistic = () => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get("summary/statistic");
};

export const getAmountOfElectricity = (params: { day_search?: string; latitude?: string; longitude?: string }, id?: Number | string) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get(`admin/place/${id}/power-usage`, { params });
};

export const getPinPlace = (params: { latitude?: string; longitude?: string }, id?: Number | string) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get(`admin/map/pin-place/${id}`, { params });
};

export const stopPlace = (params: TurnOnOff) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`facility/switching`, params);
};

export const openPlace = (params: TurnOnOff) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`facility/switching`, params);
};

export const pinPlace = (params: { latitude : number | string | undefined, longitude : number | string | undefined }) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get('/map/pin-place',{ params });
};

export const imageUpload = (filename: string, file: string | ArrayBuffer | null) => {
  const restClient = getAxiosClientWithJWTToken();
  return restClient.post(`file-upload`, { filename: filename, file: file });
};

export const imageRemove = (params: { filepath: string }) => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.post(`admin/image-remove`, params);
};

export const getFacilityUuidNames = () => {
    const restClient = getAxiosClientWithJWTToken();
    return restClient.get(`/facility/list-uuid-name`);
};
